import { requestAccessNav } from '../../static-resources/static-navigation';
import { ButtonDefault } from '../buttons/button-default.component';
import { ButtonPrimary } from '../buttons/button-primary.component';
import { MessagePageComponent } from '../message-page/message-page.component';
import './error-login-callback.component.scss';
interface ErrorLoginCallbackComponentProps {
  error: Error;
}
export const ErrorLoginCallbackComponent = ({
  error,
}: ErrorLoginCallbackComponentProps) => {
  return (
    <MessagePageComponent>
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            <div className="error-login-callback-component-container">
              <p>An error occurred:</p>
              <pre>{error.message}</pre>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="d-flex">
              <div className="pe-3">
                <ButtonDefault variant="white" path="/">
                  Go Back
                </ButtonDefault>
              </div>
              <div className="pe-3">
                <ButtonPrimary path={requestAccessNav.path}>
                  Request Access
                </ButtonPrimary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MessagePageComponent>
  );
};
